var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"wrapper\"><div style=\"display: block\" class=\"container apply-container\"><div class=\"step2 step2active question submitted active completed\"><div class=\"circle\"><div class=\"triangle-block\"><div class=\"triangle\"></div></div></div><h2>Your payment has been submitted</h2><p>Your payment has been submitted and your reports are being processed. An email will be sent to the landlord when the reports have been successfully processed.</p></div></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./components/payment/complete/complete.jade
// module id = 1176
// module chunks = 0